import wordboardService from '@/services/wordboard';
import EventBus from '@/utils/eventBus';
import * as types from './mutation-types';

export const getWords = ({ commit, state }, filter) => {
  if (!filter && state.lastFilter) {
    filter = state.lastFilter;
  }
  EventBus.$emit('show-loading', true);

  wordboardService.countAll().then((i) => {
    wordboardService.get(filter).then((res) => {
      EventBus.$emit('show-loading', false);
      commit(types.GET_WORDBOARDS, {
        lastFilter: filter,
        wordboards: res.data,
        count: i.data.count,
      });
    });
  });
};


export default {
  getWords,
};



// WEBPACK FOOTER //
// ./src/store/modules/wordboard/actions.js